import {CreateEventFormValidationSchema} from '@/features/agenda/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AgendaCreateEventFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues?: Partial<CreateEventFormValidationSchema>
}) => {
    const form = useForm<CreateEventFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(CreateEventFormValidationSchema),
        defaultValues: defaultValues || {
            type: 'event',
            category: 'treatments',
            status: 'provisional',
            isGroupTreatment: false,
            isRemote: false,
            consultants: [{fullName: '', id: ''}]
        }
    })
    return <FormProvider {...form}>{children}</FormProvider>
}
